import { useMatch } from "react-router-dom";

export function useMapURLParams(): { mapName: string, mapOption?: string } {
    const match: any =
        useMatch('/app/map/:mapName/:mapOption') ??
        useMatch('/app/map/:mapName') ??
        useMatch('/app/:id/map/:mapName');
    return match?.params ?? {}
}